import { main } from '../../assets/extras'
import { addYearToADate, addMonthToADate, compareDates, getCurrentDate } from '../../assets/validator'

export const PAYMENT_COLORS = { PAID: main, PARTIAL: "#FF8000", UNPAID: "#FF0000" }
export const SUB_PERIOD = { ANNUAL: -1, MONTHLY: -2, FIXED_DAY: 1 }

export const formatQuantity = (quantity) => {
    return new Intl.NumberFormat('es-MX').format(quantity || 0)
}

export const validatePayment = (data, field, selectedSub) => {
    const sub = data[field][0]
    if (sub.fecha_pago === "----/--/--") {
        return PAYMENT_COLORS.UNPAID
    } else {
        const getPaymentColor = (sub) => {
            if (parseFloat(sub.pagado) >= parseFloat(sub.por_pagar)) {
                return PAYMENT_COLORS.PAID
            }
            return parseFloat(sub.pagado) > 0 ? PAYMENT_COLORS.PARTIAL : PAYMENT_COLORS.UNPAID
        }

        if (selectedSub.fecha_pago === SUB_PERIOD.ANNUAL) {
            const fecha_anterior = sub.fecha_pago
            if (compareDates(getCurrentDate(), addYearToADate(fecha_anterior)) === 1) {
                return getPaymentColor(sub)
            } else if (compareDates(getCurrentDate(), addYearToADate(fecha_anterior)) === 2 || compareDates(getCurrentDate(), addYearToADate(fecha_anterior)) === 0) {
                return PAYMENT_COLORS.UNPAID
            }
        } else if (selectedSub.fecha_pago === SUB_PERIOD.MONTHLY) {
            const fecha_anterior = sub.fecha_pago
            if (compareDates(getCurrentDate(), addMonthToADate(fecha_anterior)) === 1) {
                return getPaymentColor(sub)
            } else if (compareDates(getCurrentDate(), addMonthToADate(fecha_anterior)) === 2 || compareDates(getCurrentDate(), addMonthToADate(fecha_anterior)) === 0) {
                return PAYMENT_COLORS.UNPAID
            }
        } else if (selectedSub.fecha_pago === SUB_PERIOD.FIXED_DAY) {
            let newDate = getCurrentDate().split("-")
            newDate[2] = selectedSub.dia_pago.toString()
            newDate = newDate.join("-")
            if (compareDates(sub.fecha_pago, newDate) === 1) {
                return PAYMENT_COLORS.UNPAID
            } else if (compareDates(sub.fecha_pago, newDate) === 2 || compareDates(sub.fecha_pago, newDate) === 0) {
                return getPaymentColor(sub)
            }
        }
        return PAYMENT_COLORS.UNPAID
    }
}
